<template>
    <ResponsiveDialog :value="value" @input="$emit('input', $event)" :max-width="420" :full-height="false" :header-title="$t('journey.registerLeague.title')" header-class="skin-window-header--league" card-class="skin-card">
        <div class="rld-bg skin-window--league">
            <div class="rld-banner">
                <v-img
                    :src="require('@/assets/pic/web/registration_joy.png')"
                    class="rld-banner-img"
                    contain
                />
            </div>
            <div class="rld-content">
                <div class="rld-message transparent07--dark">
                    <div>{{ $t('journey.registerLeague.confirmMessage') }}</div>
                    <div v-if="notEnoughPokemons" class="rld-warning">
                        {{ $t('journey.registerLeague.warningNotEnough') }}
                    </div>
                </div>
                <div
                    class="rld-action-pill"
                    :class="{'rld-action-pill--disabled': notEnoughPokemons || isLoading}"
                    @click="accept()"
                >
                    {{ $t('journey.registerLeague.startButton') }}
                </div>
            </div>
        </div>
    </ResponsiveDialog>
</template>

<script>
    // Popup před registrací do ligy v CityNext.vue - stejná kostra jako
    // MewtwoChallengeDialog.vue. Text hlášky zůstává schválně stejný jako
    // měl původní ConfirmDialog (vč. překlepu "trournament").
    //
    // `havingPokemonsCount` je CELKOVÝ počet pokémonů (u trenéra i u Oaka
    // dohromady) - čistě FE gate, server tenhle check nemá.
    import ResponsiveDialog from '@/components/utils/ResponsiveDialog';

    export default {
        name: 'RegisterLeagueDialog',
        components: {ResponsiveDialog},
        props: {
            value: {type: Boolean, default: false},
            havingPokemonsCount: {type: Number, default: 0},
            isLoading: {type: Boolean, default: false},
        },
        computed: {
            notEnoughPokemons() {
                return this.havingPokemonsCount < 6;
            },
        },
        methods: {
            accept() {
                if (this.notEnoughPokemons || this.isLoading) {
                    return;
                }
                this.$emit('input', false);
                this.$emit('accept');
            },
        },
    }
</script>

<style scoped>
.rld-bg {
    flex: 1 1 auto;
    min-height: 0;
    /* pozadi ridi skin (public/skins/normal.css, .skin-window--league) */
    display: flex;
    flex-direction: column;
}
.rld-banner {
    flex: none;
    height: min(25vh, 200px);
    width: 80%;
    margin: 16px auto 0;
    border-radius: 16px;
    overflow: hidden;
    background-color: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 6px 14px rgba(0,0,0,0.3), 0 2px 5px rgba(0,0,0,0.2);
}
.rld-banner-img {
    width: 100%;
    height: 100%;
}
.rld-content {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    /* rezerva pro plovouci zaviraci krizek (ResponsiveDialog), stejna hodnota
       jako ostatni next/ popupy (viz MewtwoChallengeDialog.vue) */
    padding: 24px 20px var(--responsive-dialog-close-clearance) 20px;
}
.rld-message {
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    border-radius: 14px;
    padding: 12px 16px;
}
.rld-warning {
    color: #FF5252;
    font-size: 16px;
    margin-top: 8px;
}
.rld-action-pill {
    background: #1565C0;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    padding: 12px 24px;
    border-radius: 999px;
    text-align: center;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    min-width: 65%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow:
        0 6px 14px rgba(21,101,192,0.45),
        1px 1px 4px 3px rgba(0,0,0,0.5),
        -1px -2px 6px 3px rgba(0,0,0,0.65) inset;
}
.rld-action-pill:active {
    box-shadow: 1px 1px 3px 2px rgba(0,0,0,0.7) inset;
}
.rld-action-pill--disabled {
    background: #9E9E9E;
    color: rgba(255,255,255,0.7);
    cursor: not-allowed;
    box-shadow: 1px 1px 4px 3px rgba(0,0,0,0.3), -1px -2px 6px 3px rgba(0,0,0,0.4) inset;
}
.rld-action-pill--disabled:active {
    box-shadow: 1px 1px 4px 3px rgba(0,0,0,0.3), -1px -2px 6px 3px rgba(0,0,0,0.4) inset;
}
</style>
